<template lang="pug">
  .thumb__favorite.text-primary(
    :class="{ active }"
    @click.prevent="handleClick"
    v-tooltip="title"
  )
</template>

<script>
import axios from 'axios'

export default {
  props: {
    isActive: {
      type: Boolean,
      default: false
    },

    resourceType: {
      type: String,
      required: true
    },

    resourceId: {
      type: Number,
      required: true
    }
  },

  data () {
    return {
      active: this.isActive
    }
  },

  computed: {
    title () {
      if (this.active) {
        return 'Enlever des favoris'
      }

      return 'Ajouter aux favoris'
    }
  },

  methods: {
    handleClick () {
      axios.post('/api/v1/favorites', {
        resource_type: this.resourceType,
        resource_id: this.resourceId
      })
        .then(({ data }) => {
          this.active = data
          let message = "Ajouter aux favoris"

          if (data === false) {
            message = "Retirer des favoris"
          }

          new FlashMessage(message, "success")
        })
        .catch(({ response }) => {
          this.errors = response.data.errors
          new FlashMessage(response.data.errors, "danger")
        })
    }
  }
}
</script>
